// Client-side input rules. The server stays authoritative - these only spare
// the user a round-trip and a raw validation message.
import { MIN_PASSWORD_LENGTH } from './constants';

// The browser's type="email" accepts a bare "a@b", while the backend's EmailStr
// requires a dotted domain and answers 422. Require the dot here so the user
// gets a sentence instead of "value is not a valid email address: The part
// after the @-sign...". Deliberately permissive otherwise: rejecting an address
// a real mail server would accept is worse than letting the server decide.
export const isValidEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((value || '').trim());

// Heuristic password strength for the sign-up meter (BG_62). Deliberately
// dependency-free: a full estimator like zxcvbn is overkill for a visual
// hint. Awards a point for each signal - meeting the minimum length, extra
// length, mixed letter case, a digit and a symbol - then buckets the total
// into weak / medium / strong. Returns `level: null` for empty input so the
// meter stays hidden until the user starts typing.
// Complexity policy the backend enforces in validate_password_value: at least
// one lowercase letter, one uppercase letter, one digit and one special
// character. Mirror it client-side so the user gets an inline sentence instead
// of a raw 422. The server stays authoritative.
export const meetsPasswordComplexity = (password) =>
  /[a-z]/.test(password || '') &&
  /[A-Z]/.test(password || '') &&
  /\d/.test(password || '') &&
  /[^A-Za-z0-9]/.test(password || '');

export const getPasswordStrength = (password) => {
  if (!password) return { score: 0, level: null };
  let points = 0;
  if (password.length >= MIN_PASSWORD_LENGTH) points += 1;
  if (password.length >= MIN_PASSWORD_LENGTH + 4) points += 1;
  if (/[a-z]/.test(password) && /[A-Z]/.test(password)) points += 1;
  if (/\d/.test(password)) points += 1;
  if (/[^A-Za-z0-9]/.test(password)) points += 1;
  if (points <= 2) return { score: 1, level: 'weak' };
  if (points === 3) return { score: 2, level: 'medium' };
  return { score: 3, level: 'strong' };
};
